export enum ProcessType {
  NORMAL = 'NORMAL',
  EXTERNAL = 'EXTERNAL',
}
